import React, { Component } from 'react'

import '../../App.css';
import '../styles/Team.css';

import ArrowUp from '../../assets/Arrow Up.svg';
import placeholderImage from '../../assets/download.jpeg'; // FOR TESTING PURPOSES ONLY
import PinkDiagonal from '../../assets/Pink 1 2.svg';
import PinkCurve from '../../assets/Pink 3 2.svg';
import PinkStraight from '../../assets/Pink 2 2.svg';
import YellowCircle from '../../assets/Yellow 2.svg';
import YellowCurve from '../../assets/Yellow 1 2.svg';

export default class Team extends Component {

	state = this.props.parentState;

	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this));
		this.resize();
	}

	resize() {
		this.setState({
			isHeightSmall: window.innerHeight <= 780
		})
	}

	convertDataToJSX(data) {
		let cols = [];
		let numCols = data.length / 2;

    let numRows = 2
    ;
    if (this.props.isHeightSmall || data.length < 5) {
			numRows = 1;
			numCols = data.length;
		}

		let currentArrayIndex = 0;
		for (let i = 0; i < numCols; i++) {
			let cells = [];

			for (let k = 0; k < numRows && (currentArrayIndex < data.length); k++) {

				let member = data[currentArrayIndex];
				const { name, location, picture } = member;

				cells.push(
					<div className="cell">
						<div className="content">
							<div className="image">
								<img src={picture} className="asset" />
							</div>
							<div className="name">{name}</div>
							<div className="location">{location}</div>
						</div>
					</div>
				);

        /*if (i % 2 == 0) { // render pink doodles

          if (k == 0) {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={placeholderImage} className="asset" />
                    <img src={PinkDiagonal} className="pink-right-doodle" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          } else if (k == 2) {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={placeholderImage} className="asset" />
                    <img src={PinkStraight} className="pink-straight-right-doodle" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          } else if (k == 4) {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={PinkCurve} className="pink-left-doodle" />
                    <img src={placeholderImage} className="asset" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          } else {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={placeholderImage} className="asset" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          }

        } else { // render yellow doodles

          if (k == 1) {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={placeholderImage} className="asset" />
                    <img src={YellowCurve} className="yellow-right-doodle" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          } else if (k == 3) {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={YellowCircle} className="yellow-left-doodle" />
                    <img src={placeholderImage} className="asset" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          } else {
            cells.push(
              <div className="cell">
                <div className="content">
                  <div className="image">
                    <img src={placeholderImage} className="asset" />
                  </div>
                  <div className="name">{name}</div>
                  <div className="location">{location}</div>
                </div>
              </div>
            );
          }

        }*/

				currentArrayIndex++;
			}

			cols.push(cells);
		}

		let content = [];
		cols.forEach(function (cells) {
			content.push(<div className="column">
				{cells}
			</div>);
		})

		return content;
	}

	render() {

    let content = null;
    if (this.props.isLoading) {
      content = <div className="loading-text">Loading...</div>;
    } else {
      content = this.convertDataToJSX(this.props.members);
    }

		return (

			<div className="vertical-flex-container">

				<div className="subpage-bottom-button-container">
					<div className="button" onClick={this.props.upAction}>
						<img src={ArrowUp} className="upArrow" />
						Meet the Team
          </div>
				</div>

				<div className="subpage-bottom-main-content-container">
					<div className="team-content-container">
          
						<div className="description-container">
							<div className="description-text-container">
								{this.props.description}
							</div>
						</div>

						<div className="members-container">
							<div className="wrapper">
								{content}
							</div>
						</div>

					</div>
				</div>

			</div>
		)
	}
}
